export default "__VITE_ASSET__97e115ef__"